// extracted by mini-css-extract-plugin
export default {"statusBadge":"IssueStatusBadge_statusBadge__b+IQL","text":"IssueStatusBadge_text__9+Mqx"};